import { render } from "./ContactForm.vue?vue&type=template&id=08e78ac2"
const script = {}

import "./ContactForm.vue?vue&type=style&index=0&id=08e78ac2&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__